export const USER = "user";

//Base Roles
export const SUPER_ADMIN = "super admin";
export const ADMIN = "admin";
export const ADMINS = [ADMIN, SUPER_ADMIN];
export const WORKER = "worker";
export const STAFF = "staff";
export const DRIVER = "driver";
export const TUTOR = "tutor";
export const CUSTOMER = "customer";

//OTP-types
export const EMAIL_OTP = "email otp";
export const AUTHENTICATOR_OTP = "authenticator OTP";
export const OTP_TYPES = [EMAIL_OTP, AUTHENTICATOR_OTP];

//Profile tabs
export const BASIC_INFO = "Basic Info";
export const SECURITY = "Security";
export const SETTINGS = "Settings";
export const ACTIVITIES = "Activities";

export const XLSX = ".xlsx"; //Excel
export const PDF = ".pdf";
export const EXPORT_FORMATS = [XLSX];

//Order Statuses
export const UNAPPROVED = "unapproved";
export const APPROVED = "approved";
export const DEPARTED = "departed";
export const INITIALIZED = "initialized";
export const COMPLETED = "completed";
export const ORDER_STATUSES = [UNAPPROVED, APPROVED, INITIALIZED, COMPLETED];

//OrderTimeStampExtension Statuses
export const RENTAL_TIME_FRAME_EXTENSION_STATUSES = [APPROVED, UNAPPROVED];

//RentalPackage status
export const AWAITING_APPROVAL = "awaiting approval";
export const AWAITING_DELIVERY = "awaiting delivery";
export const AWAITING_RETRIEVAL = "awaiting retrieval";
export const IS_HISTORY = "is history";
export const RENTAL_PACKAGE_STATUSES = [
  AWAITING_APPROVAL,
  AWAITING_DELIVERY,
  AWAITING_RETRIEVAL,
  IS_HISTORY,
];

export const COMPANY = "company";
export const COMPANY_SITE = "company site";

export const ORDER = "rental order";
export const PAYMENT = "payment";
export const RENTAL_TIME_FRAME_EXTENSION = "rental time frame extension";
export const RENTAL_ITEM = "rental item";

//status
export const ACTIVE = "active";
export const DISABLED = "disabled";
export const ACTIVITY_STATUSES = [ACTIVE, DISABLED];

//Measurements' units
export const LITRE = "ltr";
export const KILOGRAM = "kg";
export const PIECE = "PC";
export const UNITS = [LITRE, KILOGRAM, PIECE];

//rental-items types
export const COURSE = "course";
export const ARTICLE = "article";
export const SELLABLE_PRODUCT = "sellable product";
export const RECOREDED_WORKSHOP = "recorded workshop";
export const MEMBERSHIP = "membership";
export const SME_EVENT = "event";
export const RENTAL_ITEMS_TYPES = [
  COURSE,
  ARTICLE,
  RECOREDED_WORKSHOP,
  MEMBERSHIP,
  SME_EVENT,
];

//membership types
export const SILVER = "silver";
export const GOLD = "gold";
export const PLATINUM = "platinum";
export const DIAMOND = "diamond";
export const MEMBERSHIP_TYPES = [SILVER, GOLD, PLATINUM, DIAMOND];
export const MAX_MEMBERSHIP_TYPE = DIAMOND;

//payment-types
export const CREDIT_PAYMENT = "credit payment";
export const GATEWAY_PAYMENT = "online payment";
export const EXTERNAL_PAYMENT = "bank transfer";
export const PAYMENT_TYPES = [
  CREDIT_PAYMENT,
  GATEWAY_PAYMENT,
  EXTERNAL_PAYMENT,
];

//event phases
export const ONGOING_REGISTERATION = "ONGOING REGISTRATION";
export const JOIN_NOW = "JOIN NOW";
export const PAST = "PAST EVENT";

//special roles
export const FOUNDER = "Founder of SME Scaleup";
export const MARKETING_COORDINATOR = "Marketing Coordinator";
export const FINANCIAL_ANALYST = "Financial Analyst";
export const PROGRAM_MANAGER = "Program Manager";
export const CUSTOMER_SUPPORT_SPECIALIST = "Customer Support Specialist";
export const SPECIAL_ROLES = [
  FOUNDER,
  MARKETING_COORDINATOR,
  FINANCIAL_ANALYST,
  PROGRAM_MANAGER,
  CUSTOMER_SUPPORT_SPECIALIST,
];

//sme-owners statuses
export const SME_OWNER_VERIFIED = "verified";
export const SME_OWNER_UNVERIFIED = "unverified";
export const SME_OWNER_STATUSES = [SME_OWNER_UNVERIFIED, SME_OWNER_VERIFIED];

export const USER_TARGET = "user";
export const RENTAL_ITEM_TARGET = "rental item";
export const RENTAL_ITEM_ATTACHMENT_TARGET = "rental item attachment";
export const MESSAGE_TARGETS = [
  USER_TARGET,
  RENTAL_ITEM_TARGET,
  RENTAL_ITEM_ATTACHMENT_TARGET,
];

//session action
export const SESSION_ABORT = "abort";
export const SESSION_COMPLETE = "complete";
export const SESSION_ACTIVATE = "activate";
